// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casevalidation-details-root
  .dps-side-panel
  .slide-pane
  .wlb-slider-Content
  .wlb-slider-header {
  /* padding: 16px 24px; */
  display: flex;
  padding: 16px 24px;
  padding-top: 30px;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  font-family: Roboto;
  font-weight: 700;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 160%;
  letter-spacing: 0.15px;
}
.casevalidation-details-root .dps-side-panel .slide-pane .wlb-slider-Content {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/sidepanel/DpsSidePanel.css"],"names":[],"mappings":"AAAA;;;;;EAKE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".casevalidation-details-root\n  .dps-side-panel\n  .slide-pane\n  .wlb-slider-Content\n  .wlb-slider-header {\n  /* padding: 16px 24px; */\n  display: flex;\n  padding: 16px 24px;\n  padding-top: 30px;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  font-family: Roboto;\n  font-weight: 700;\n  font-size: 20px;\n  leading-trim: NONE;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n}\n.casevalidation-details-root .dps-side-panel .slide-pane .wlb-slider-Content {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
